import { Search } from "lucide-react";
import { getUser } from "@/lib/api";
import NotificationsBell from "@/components/NotificationsBell";

export default function Header({ title, subtitle }) {
  const user = getUser();
  const initials = (user?.name || user?.email || "?").slice(0, 2).toUpperCase();
  return (
    <header className="sticky top-0 z-20 bg-white/80 backdrop-blur-xl border-b border-slate-200 px-8 py-4 flex items-center gap-4" data-testid="app-header">
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-0.5">{subtitle || "Dashboard"}</div>
        <h1 className="font-display font-bold text-slate-900 text-xl md:text-2xl tracking-tight truncate">{title}</h1>
      </div>
      <div className="hidden md:flex items-center gap-2 bg-slate-100 rounded-xl px-3 py-2 w-72">
        <Search className="w-4 h-4 text-slate-400" />
        <input
          data-testid="header-search-input"
          className="bg-transparent outline-none text-sm flex-1"
          placeholder="Search courses, students, tasks…"
        />
      </div>
      <NotificationsBell />
      <div className="flex items-center gap-2" data-testid="user-badge">
        <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-blue-500 to-violet-500 text-white flex items-center justify-center text-xs font-bold">
          {initials}
        </div>
        <div className="hidden lg:block">
          <div className="text-sm font-medium text-slate-800 leading-tight">{user?.name || "Guest"}</div>
          <div className="text-xs text-slate-500 capitalize">{user?.role}</div>
        </div>
      </div>
    </header>
  );
}
